import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'
import scrollTo from '../utils/helpers/scrollTo'

class Nav {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.header = document.querySelector('header');
      cache.sections = document.querySelectorAll('section');
      cache.sub = document.querySelectorAll('.nav_mobile .menu-item-has-children');
      cache.navmobileBtn = document.querySelector('.nav .burger_icon');
      anime({
        targets: cache.header,
        translateY: ['-100%', '0%'],
        delay: 1000,
        duration: 500,
        easing: 'easeOutQuad',
      });
    };

    let registerEvents = () => {
      cache.navmobileBtn.addEventListener("click", toggleNavMobile);
      for (let i = 0; i < cache.sub.length; i++) {
        cache.sub[i].addEventListener("click", toggleSubMobile);
      }
    };

    let toggleNavMobile = () => {
      if(cache.header.classList.contains('open')) {
        cache.header.classList.remove('open');
        utils.enableScroll();
      } else {
        cache.header.classList.add('open');
        utils.disableScroll();
      }
    }

    let toggleSubMobile = function() {
      const subBtn = this;
      const sub = this.querySelector('.sub-menu');
      if(!subBtn.classList.contains('open')) {
        subBtn.classList.add('open');
        sub.style.display = "block";
        sub.style.height = "auto";
        const height = sub.offsetHeight;
        sub.style.height = 0;
        anime({
          targets: sub,
          height: [0,height],
          duration: 400,
          easing: 'easeOutQuad'
        });
      } else {
        subBtn.classList.remove('open');
        anime({
          targets: sub,
          height: [sub.offsetHeight, 0],
          duration: 400,
          easing: 'easeOutQuad',
          complete: function() {
            sub.style.display = "none";
          }
        });
      }

    }

    initFunc();
  };
}
export { Nav }
